module.exports = __webpack_public_path__ + "9e45a0ad033f43bb2ce1fa14ef934f88.svg";